import React, { useState,useEffect } from "react";
import secureStorage from "@src/config/encrypt";
import { toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
import FullPageLoader from '@src/common/FullPageLoader';
import ChangePasswordModal from './ChangePasswordModal';
import AddApplicationThankPopup from '@src/pages/insurance/AddApplicationThankPopup';


const Profile = () => {

    const navigate = useNavigate();
    const[userData , setUserData] = useState<any>('')
    const [loading, setLoading] = useState<boolean>(true);
    const [showChangePasswordPopup, setShowChangePasswordPopup] = useState<boolean>(false);
    const [showPasswordChnageSuccess, setShowPasswordChnageSuccess] = useState<boolean>(false);

    const handleClose = () => {
        setShowChangePasswordPopup(false);
    }

    const handleChangePassword = () => {
        setShowChangePasswordPopup(true);
    }

    const logOutUser = async () => {
        let result = secureStorage.getItem("authAgentUserInfo")
        if (result) {
            secureStorage.removeItem("authAgentUserInfo")
            toast.success('LogOut Successfully')
            setTimeout(() => { navigate('/login'); }, 100)
        }
    };

    const fetchUserData = () => {
        let result = secureStorage.getItem("authAgentUserInfo");
        setUserData(result.user_data);
        setLoading(false);
    };

    useEffect(() => {
        fetchUserData();
      } , [])

      const goToDeleteAcc = () => {
        navigate('/delete/account');
      }

      const showSuccessPopup = (show_success_popup:boolean) => {
        setShowChangePasswordPopup(false);
        setShowPasswordChnageSuccess(show_success_popup);
      }

      const navigateToProfile = () => {
        setShowPasswordChnageSuccess(false);
        navigate("/my-profile");
      }

      const updateLastUpdatedPwd = (lastUpdatedPwd: string) => {
        setUserData((prevUserData: any) => {
            const updatedUserData = {
                ...prevUserData,
                last_updated_pwd: lastUpdatedPwd, // Update the last_updated_pwd in userData
            };
             // Update localStorage
             const authAgentUserInfo = secureStorage.getItem("authAgentUserInfo") || {};
             secureStorage.setItem("authAgentUserInfo", {
                 ...authAgentUserInfo,
                 user_data: updatedUserData,
             });
             return updatedUserData;
        });
    };


    return (
        <React.Fragment>
            <FullPageLoader show={loading} />
            <ChangePasswordModal show={showChangePasswordPopup} handleClose={handleClose} onSuccess={(response: any) => {
                showSuccessPopup(response.show_success_popup);
                updateLastUpdatedPwd(response.last_updated_pwd);
            }}></ChangePasswordModal>
             <AddApplicationThankPopup show={showPasswordChnageSuccess} handleClose={() => {
                    setShowPasswordChnageSuccess(false)
                }} screenType="CHANGE_PASSWORD" navigateToProfile={navigateToProfile}/>
            <div className="container-fluid profile-page">
                <div className="lead-top-heading p-lg-t">
                    <h1>My Profile</h1>
                </div>
                <div className="user-profile-outer m-lg-t">
                    <div className="row p-lg-t">
                        {/* Left side card */}
                        <div className="col-md-4 col-xs-12">
                            <div className="card profile-image-outer">
                                <div className="profile-img-container">
                                    <img
                                        src="/images/profile_icon.png"
                                        alt="Profile"
                                        className="profile-img rounded-circle"
                                    />
                                </div>
                                <span className="user-name">{userData?.name ?? ''}</span>
                                <span className="user-detail">ID - {userData?.id ?? ''}</span>
                                <span className="user-detail">{userData?.email ?? ''}</span>
                                <div className="profile-logout-container mt-4">
                                    <a href="#logout" onClick={logOutUser}>
                                        Logout
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* Right side card */}
                        <div className="col-md-8 col-xs-12">
                            <div className="card user-profile-details">
                               
                                    <ul className="profile-info">
                                        <li>
                                            <span>Name:</span>
                                            <label>{userData?.name ?? ''}</label>
                                        </li>
                                        <li>
                                            <span>Profile Status:</span>
                                            <label className={`status-txt ${userData?.status ? 'status-active' : 'status-inactive'}`}>
                                                <i className={`ic-check ${userData?.status ? 'text-success' : 'text-danger'}`}></i>
                                                {userData?.status ? "Active" : "Inactive"}
                                            </label>
                                        </li>
                                        <li>
                                            <span>ID:</span>
                                            <label>{userData?.id ?? ''}</label>
                                        </li>
                                        <li>
                                            <span>Email ID:</span>
                                            <label>{userData?.email ?? ''}</label>
                                        </li>
                                        <li>
                                            <span><a href="#change-password"  onClick={(e) => {
                                                e.preventDefault();
                                                handleChangePassword();
                                            }}>Change Password:</a></span>
                                            {
                                                userData?.last_updated_pwd &&
                                                <label>
                                                    Last Updated : {userData?.last_updated_pwd 
                                                                ? new Date(userData?.last_updated_pwd).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).replace(',', '')
                                                                : ''}
                                                </label>
                                            }
                                        </li>
                                        <li>
                                            <span className="delete-txt" onClick={goToDeleteAcc}>Delete Account</span>
                                        </li>
                                    </ul>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Profile;
